import axios from "axios"
import { useEffect, useState } from "react"
import { TabList, TabPanel, TabContext } from '@mui/lab';
import Tab from '@mui/material/Tab';
import { useNavigate, useSearchParams } from "react-router-dom";
// const [searchParams,] = useSearchParams();



import { Box } from '@mui/system';
import VerticalSwiper from "./VerticalSlider";
import { useAuth } from "../../../providers/auth-provider";
import ArenaHeader from "../../../GamesArena/Common/ArenaHeader";
import { addDoc, collection } from "firebase/firestore";
import { db } from "../../../firebase-config";
import { Dialog } from "@mui/material";
import AppButton from "../../Common/AppButton";
import mixpanel from 'mixpanel-browser';
// import ProgressTracker from "./ProgressTracker";


const LearnTopic = () => {

    const { user, isUserLoading, dontShowUpdateDetails } = useAuth();
    const [currentTopicQuestions, setCurrentTopicQuestions] = useState([])
    const [uniqueSubTopics, setUniqueSubTopics] = useState([])
    const [value, setValue] = useState(1);
    const navigate = useNavigate();
    const [searchParams,] = useSearchParams();
    const [answers, setAnswers] = useState([{}])
    const [filteredTopicQuestions, setFilteredTopicQuestions] = useState([])
    const [showPopup, setShowPopup] = useState({ show: false, type: "" });

    const [gameId, setGameId] = useState(null)
    const [showCompletedPopup, setShowCompletedPopup] = useState({ show: false, type: "" });

    const [gameState, setGameState] = useState({})
    const [filterOption, setFilterOption] = useState("all");


    const topicId = searchParams.get("tid");
    const back = searchParams.get("back");

    useEffect(() => {
        //filter question based on filterOption

        const filteredQuestions = currentTopicQuestions.filter((question) => {
            return question.skill === filterOption || filterOption === "all"
        })
        setFilteredTopicQuestions(filteredQuestions)

        mixpanel.identify(user.id);
        mixpanel.track('Revise_Filter', {
            filter: filterOption,
        });
        // setActiveIndex(0)

    }, [filterOption, currentTopicQuestions])


    useEffect(() => {
        const learnTopicQuestions = async () => {
            try {
                const response = await axios.post(`${process.env.REACT_APP_NODE_BASE_URL}/practice-arena/revise-topic-questions`,
                    //change this to topic url ***
                    {
                        topicId,
                        grade: user?.grade,
                        mode: "learn"
                    }
                )
                const dummyData = response.data.data

                const questionData = dummyData;

                //get an array of unique subtopics
                const questionsSubTopicArray = questionData.map((question) => question.skill)
                const uniqueSubTopics = [...new Set(questionsSubTopicArray)]
                setUniqueSubTopics(uniqueSubTopics);
                setCurrentTopicQuestions(questionData)
            }
            catch (error) {
                console.log(error)
            }
        }
        learnTopicQuestions();
    }, [])


    useEffect(() => {
        if (answers.length === currentTopicQuestions.length) {
            const allAnswered = answers.every((answer) => answer.submitted && answer.isCorrect)
            if (allAnswered) {
                setShowCompletedPopup({ show: true, type: "" });
            }
        }
    }, [answers])

    //some how we need to make sure that the number tabs are less than 4/5


    const handleBack = () => {
        // if (answers?.length != currentTopicQuestions?.length) {
        //     setShowPopup({ show: true, type: "" });
        // }
        if (!!back) {
            navigate(`/${back}`)
        }
        else {
            navigate("/lobby")
        }
    }

    const handleExit = async () => {
        if (!!back) {
            navigate(`/${back}`)
        }
        else {
            navigate("/lobby")
        }
    }

    const leaveModulePopup = () => {
        return (
            <Dialog
                open={showPopup.show}
                onClose={() => {
                    setShowPopup({ show: false, type: "" });
                    //   localStorage.setItem("hideQualificationPopup", "true");
                }}
                className="register-success"
            >
                <div className="relative flex flex-col bg-primary-gradient text-white h-full overflow-hidden px-6 py-6 leading-6 text-base">

                    <ul className="my-6 mx-0 flex flex-col gap-4">
                        <p className="my-2 mx-0 ml-[-30px] text-center text-[20px]">
                            {"You have not completed the module yet"}
                        </p>
                        <p className="my-2 mx-0 ml-[-30px] text-center">
                            {"Are you sure you want to leave?"}
                        </p>
                    </ul>
                    <div className='flex flex-col items-center justify-center w-full h-full'>
                        <AppButton
                            onClick={() => { setShowPopup({ show: false, type: "" }); }}
                            className="rounded-[115px] min-w-[150px] w-[100px] h-[35px] min-h-[35px] self-center items-center"
                        >
                            Back to Module
                        </AppButton>

                        <div
                            className="flex flex-col items-center justify-center w-full h-full text-[#ccf900] text-[14px] mt-4"
                            // onClick={() => navigate('/practice-arena')}
                            onClick={() => handleExit()}
                            style={{ textDecoration: 'underline', cursor: 'pointer' }}
                        >
                            Exit
                        </div>
                    </div>
                </div>
            </Dialog>
        );
    }

    const completedModulePopup = () => {

        return (
            <Dialog
                open={showCompletedPopup.show}
                onClose={() => {
                    setShowCompletedPopup({ show: false, type: "" });
                    //   localStorage.setItem("hideQualificationPopup", "true");
                }}
                className="register-success"
            >
                <div className="relative flex flex-col bg-primary-gradient text-white h-full overflow-hidden px-6 py-6 leading-6 text-base">

                    <ul className="my-6 mx-0 flex flex-col gap-4">

                        <p className="my-2 mx-0 ml-[-30px] text-center text-[20px]">
                            {"Congratulations, you have completed this module"}
                        </p>
                        {/* <p className="my-2 mx-0 ml-[-30px] text-center">
                            {"want to start practice on the same topic?"}
                        </p> */}
                    </ul>
                    <div className='flex flex-col items-center justify-center w-full h-full'>
                        <AppButton
                            onClick={() => { setShowCompletedPopup({ show: false, type: "" }); /*navigate(`/practice-arena-lobby?tid=${topicId}`)*/ window.location.href = `/lobby` }}
                            className="rounded-[115px] min-w-[150px] w-[100px] h-[35px] min-h-[35px] self-center items-center"
                        >
                            Proceed
                        </AppButton>

                        {/* <div
                            className="flex flex-col items-center justify-center w-full h-full text-[#ccf900] text-[14px] mt-4"
                            // onClick={() => navigate('/practice-arena')}
                            onClick={() => window.location.href = "/practice-arena"}
                            style={{ textDecoration: 'underline', cursor: 'pointer' }}
                        >
                            Exit
                        </div> */}
                    </div>
                </div>
            </Dialog>
        );
    }

    const getStyle = (filterIndex, primaryFilterOption) => {

        return {
            backgroundColor: "#4e4e4e",
            color: "#ccf900",
            border: "2px solid #ccf900",
        };
    };


    return (

        <div className="flex flex-col items-start justify-start w-full h-full bg-[#4e4e4e]">
            <ArenaHeader goBack={handleBack} headerText={`${topicId}`} nonArenaRoute={true} />

            <div className="flex items-center justify-center gap-4 pt-4 pb-4">
                <span className="text-white ml-[7.5vw]"> Filters: </span>
                <select
                    value={filterOption}
                    onChange={(e) => {

                        setFilterOption(e.target.value);
                    }}
                    className="text-center rounded-lg p-1 cursor-pointer h-[29px] text-[14px]"
                    style={getStyle(0, filterOption)}
                >
                    <option value="all">All</option>

                    {uniqueSubTopics?.map((subTopic, index) => (
                        <option key={index} value={subTopic}>
                            {subTopic}
                        </option>
                    ))}

                </select>
            </div>
            <div className="flex flex-col items-center justify-center w-[100%]">
                <VerticalSwiper questions={filteredTopicQuestions} setValue={setValue} uniqueSubTopics={uniqueSubTopics}
                    setAnswers={setAnswers}
                    answers={answers}
                    filterOption={filterOption}
                // setActiveIndex={setActiveIndex}
                />
            </div>

            {/* {leaveModulePopup()} */}
            {completedModulePopup()}

        </div>
    )
}

export default LearnTopic